import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { useMemo, useState } from 'react';
import { globalStyles } from 'theme/styles';

interface ITabItem {
	label: string;
	content: React.ReactNode;
}

interface ITabsComponentProps {
	tabs: ITabItem[];
	indexTab: number;
	onChange: (nextIndex: number) => void;
}
export const useTabControl = () => {
	const [activeTab, setActiveTab] = useState(0);
	return { activeTab, changeActiveTab: setActiveTab };
};
const GenericTabs = ({ tabs, indexTab, onChange }: ITabsComponentProps) => {
	const defaultStyleProps = useMemo(
		() => ({
			_selected: {
				color: globalStyles.colors.easyBLUE['700'],
				borderBottom: '1px solid',
				borderColor: globalStyles.colors.easyBLUE['700'],
			},
			_hover: {
				backgroundColor: globalStyles.colors.secondaryGray['175'],
			},
			_focus: {
				outline: '0 !important',
			},
			color: 'easyBLUE.300',
		}),
		[]
	);

	return (
		<Tabs
			variant='line'
			size='sm'
			align='start'
			w='100%'
			h={'100%'}
			display={'flex'}
			flexDirection='column'
			onChange={onChange}
			index={indexTab}
		>
			<TabList w='100%'>
				{tabs.map((tab, index) => (
					<Tab
						key={index}
						{...defaultStyleProps}
					>
						{tab.label}
					</Tab>
				))}
			</TabList>

			<TabPanels
				w='100%'
				h={'100%'}
				gap={1}
			>
				{tabs.map((tab, index) => (
					<TabPanel
						w='100%'
						h={'100%'}
						key={index}
					>
						{index === indexTab ? tab.content : null}
					</TabPanel>
				))}
			</TabPanels>
		</Tabs>
	);
};

export default GenericTabs;
